export default __webpack_public_path__ + "eb6f4eb181092fe54570fb65d256b2d9.png";